<template>
  <div class="containerVideoAvatarPreviewGenerator">
    <transition name="fade">
      <div
        class="avatarPreview"
        :class="avatarSelected"
        :style="{ backgroundImage: `url(${avatarThumbnailUrl})` }"
        v-show="!isPreviewText2Speech"
      ></div>
    </transition>
    <transition name="fade">
      <video
        class="videoAvatarPreview"
        v-show="isPreviewText2Speech"
        ref="videoAvatarPreview"
        :src="transparentAvatarVideo"
        muted
      />
    </transition>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import { CREATE_TMP_CHUNK_VIDEO } from "@/store/media/mediaAction";
import { Slide } from "@/store/slides2Video/slides2VideoModels";
import { clone } from "@/utils/cloneUtil";
import { updateCurrentSlide } from "@/utils/slides/slideUtil";
import { AVATAR_SOURCE_BUCKET } from "@/store/conf/api";
import { AvatarStyle } from "@/store/AIAvatar/aiavatarGenerationModel";

@Component({})
export default class VideoAvatarPreview extends Vue {
  get avatarSelected() {
    return store.getters.getAvatarSelected;
  }
  get avatarThumbnailUrl() {
    return `${process.env.BASE_URL}AIAvatar/${this.avatarSelected.toUpperCase()}.png`;
  }
  get transparentAvatarVideo() {
    return (
      AVATAR_SOURCE_BUCKET +
      "/" +
      this.avatarSelected.toLowerCase() +
      "/" +
      this.avatarSelected +
      "_transparent.webm"
    );
  }
  get isPreviewText2Speech() {
    return store.getters.isPreviewSpeech2Text;
  }

  @Watch("isPreviewText2Speech")
  private controlVideoPlayer() {
    const videoPlayer = this.$refs["videoAvatarPreview"] as HTMLVideoElement;
    if (!videoPlayer) {
      return;
    }
    if (this.isPreviewText2Speech) {
      videoPlayer.currentTime = 0;
      videoPlayer.play();
    } else {
      videoPlayer.currentTime = 0;
      videoPlayer.pause();
    }
  }
}
</script>

<style lang="scss" scoped>
.containerVideoAvatarPreviewGenerator {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  .videoAvatarPreview {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatarPreview {
    animation-delay: 0.5s;
    position: absolute;
    border: solid 1px var(--light1);
    border-radius: 12px;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
}
</style>
